(function () {
  if (window.BloomrVariantMaterials) return;

  function updateMaterialDisplay(container, variant) {
    const valueElement = container.querySelector('[data-variant-material-value]');
    if (!valueElement) return false;

    const material = (variant?.material || '').trim();
    const color = variant?.options?.[Number(container.dataset.colorIndex)] || '';
    const colorElement = container.querySelector('[data-variant-color-value]');
    valueElement.textContent = material || '—';
    if (colorElement) colorElement.textContent = color || '—';
    container.hidden = !material;
    return true;
  }

  function update(sectionId, variantId) {
    const data = Array.from(document.querySelectorAll('[data-variant-materials]')).find(
      (element) => element.dataset.section === String(sectionId),
    );
    if (!data) return;

    let materials;
    try {
      materials = JSON.parse(data.textContent);
    } catch {
      return;
    }

    const value = materials[String(variantId)];

    const section = data.closest('.shopify-section') || document;
    section.querySelectorAll('[data-variant-material-display]').forEach((container) => {
      updateMaterialDisplay(container, value);
    });
  }

  document.addEventListener('product:variant-change', (event) => {
    update(event.detail?.sectionId, event.detail?.variant?.id);
  });

  window.BloomrVariantMaterials = { updateMaterialDisplay, update };
})();
